export default {
  LOAD_GUEST_USER_TOKEN (state, payload) {
    state.guestUserToken = payload
  },
  LOAD_GUEST_USER (state, payload) {
    state.guestUser = payload
  },
  LOAD_ENTITY_TYPE_LABEL_CONFIGURATION (state, payload) {
    state.entityTypeLabelConfiguration = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/guest/vuex/mutations.js